import usePrivateAxios from "@/common/api/usePrivateAxios"
import { defaultTransformerResponse } from "@/common/constants/defaultTransformerResponse.constant"
import { Mapper } from "@/common/services/mapper"
import { MetaResponse } from "@/common/types/metaResponse"
import { keepPreviousData, useQuery } from "@tanstack/react-query"

type UseAvailableUsersForBranchAccessProps<T> = {
  filters?: {
    search?: string;
    page?: number;
    branchId?: string;
  };
  mapper?: (data: any) => T;
}

export const useAvailableUsersForBranchAccess = <T,>({
  filters: { search = '', page, branchId } = {},
  mapper = Mapper.default<T>(),
}: UseAvailableUsersForBranchAccessProps<T>) => {
  const privateAxios = usePrivateAxios();

  const {
    data: { data, meta } = defaultTransformerResponse<T>(),
    isPending,
    ...rest
  } = useQuery({
    queryKey: ['availableUsersForBranchAccess', branchId, search, page],
    queryFn: () => {
      return privateAxios.get(`/companies/available_users_for_branch_access`, {
        params: {
          search,
          page,
          'q[branch_id_not_eq]': branchId,
        }
      })
    },
    select: (data: { data: { data: any[], meta: MetaResponse } }) => {
      return {
        data: mapper(data?.data?.data),
        meta: data?.data?.meta,
      };
    },
    placeholderData: keepPreviousData,
  });

  return { data, meta, isPending, ...rest };
}
